import * as React from 'react';
import { Box, Typography } from '@mui/material';
import pxToRem from 'assets/theme/function/px-to-rem';
import borders from 'assets/theme/base/borders';
import Filter from 'component/filter';
import BackNavigate from 'component/back-navigate/back-navigate';
import { useParams } from 'react-router-dom';
import TeamUsers from 'pages/team/team-info/team-users';
import Image from 'component/image/image';
import TeamParams from 'pages/team/team-info/team-info';
import { useTeamDetailsQuery } from 'store/slices/team/team';

const TeamInfo: React.FC = () => {
    const { teamId } = useParams();
    const { data } = useTeamDetailsQuery({ teamId: teamId ?? '' });

    return (
        <>
            <Filter display={true} />
            <Box borderRadius={borders.borderRadius.md} mt={pxToRem(7)}>
                <Box mb={pxToRem(5)} display="grid" alignItems="center">
                    <BackNavigate navigateUrl={'/team'} />
                    <Typography variant={'h5'}>Team info</Typography>
                </Box>
                <Box display={'flex'} flexBasis={'100%'}>
                    <Image userId={data?.avatarId} />
                    <TeamParams data={data} />
                </Box>
                <Box pt={pxToRem(20)}>
                    <TeamUsers data={data} />
                </Box>
            </Box>
        </>
    );
};
export default TeamInfo;
